import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import DataTable from "../../../../Components/UiComponents/DataTable";
import { all } from "../../../../Services/userService";
import CheckboxElement from "../../../../Components/UiComponents/CheckboxElement";
import { updatePrivileges } from "../../../../Services/userService";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import { Dialog } from "primereact/dialog";
import HeaderSearchBar from "../../../../Components/UiComponents/HeaderSearchBar";
import { getControlField } from "../../../../Services/tooltipService";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from "../../../../Components/Videos/PlaylistVideos";

const Permissions = () => {
    const [customerId, setCustomerId] = useState(null);
    const [branch, setBranch] = useState([]);
    const [privileges, setPrivileges] = useState([]);
    const customerData = localStorage.getItem("enduser");
    if (customerData) {
        var customerDataInJSON = JSON.parse(customerData);
    }
    const [visible, setVisible] = useState(false);
    const [selectedPrivileges, setSelectedPrivileges] = useState({});
    const [searchQuery, setSearchQuery] = useState("");
    const [searchedLength, setSearchedLength] = useState(0);
    const [filterPrivileges, setFilterPrivileges] = useState([]);
    const [projectModule, setProjectModule] = useState([]);
    const [cntlPannel_Permissions, setCntlPannel_Permissions] = useState([]);
    const [controlUser, setControlUser] = useState([]);
    const [controlPermissionHeader, setControlPermissionHeader] = useState([]);
    const [controlPermissionTable, setControlPermissionTable] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showVideo, setShowVideo] = useState(false);
    const navigate = useNavigate()

    const toastRef = useRef()
    if(customerDataInJSON === null){
            navigate("/login")
            localStorage.clear()
    } else {
        var branchData = customerDataInJSON?.branch
    }

    useEffect(() => {

        if (customerData) {
            setCustomerId(customerDataInJSON?.customer);
            setBranch(customerDataInJSON?.branch);
        }
    }, []);

    useEffect(() => {
        if (customerId) {
            getPermissions();
            controlFields();
        }
    }, [customerId]);

    const rowClick = async (data) => {
        if (data?.firstname) {
            setVisible(true);
            setSelectedPrivileges(data)
        }
    };

    const handleHide = () => {
        setVisible(false);
    };

    const renderFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="Close" className="cancel-new-button" onClick={handleHide} />
                    {/* <ButtonElement type="submit" label="Yes" className="save-button" onClick={deleteField} /> */}
                </div>
            </div>
        );
    };

    const controlFields = async () => {
        try {
            if (customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            const clientModuleDataResponse = await getControlField(customerId);
            const clientModuleData = clientModuleDataResponse?.data;
            if (clientModuleData) {
                const projectModules = clientModuleData.cust[0].modules.find(
                    (module) => module.module_name === "Control Panel"
                ).tabs;
                setProjectModule(projectModules);
                const cntlPannel_Permissions = projectModules.find(
                    (tab) => tab.tab_name === "Permissions"
                ).display_name;
                setCntlPannel_Permissions(cntlPannel_Permissions);
                var cntlPannel_User = projectModules.find((tab) => tab.tab_name === "Users").display_name;
                setControlUser(cntlPannel_User)
                var cntlPannelPermissions = _.find(projectModules, { tab_name: "Permissions" }).tables;
                setControlPermissionTable(cntlPannelPermissions)
                var cntlPannelPermissionsHeaders = _.find(cntlPannelPermissions, { table_name: "Permissions" }).headers;
                setControlPermissionHeader(cntlPannelPermissionsHeaders)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const getPermissions = async () => {
        try {
            if (customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            if (customerId !== null) {
                const response = await all(customerId, "firstname", 1, branchData);
                const updatedPrivileges = response?.data.map(privilege => ({
                    ...privilege,
                    isPrevDisable: false // Set isPrevDisable to false by default
                }));
                // setPrivileges(updatedPrivileges);
                // setFilterPrivileges(updatedPrivileges)
                var userIndex = _.findIndex(response.data, { _id: customerDataInJSON.userid });
                if (response && response.data[userIndex]) {
                    response.data[userIndex].isAdminDisable = true;
                    response.data[userIndex].isPrevDisable = true;
                }
                var adminUsers = response.data.filter((value) => {
                    return value.isAdmin === true && value._id !== customerDataInJSON.userid;
                });
                for (var i = 0; i < adminUsers.length; i++) {
                    var tmpIndex = _.findIndex(response.data, { _id: adminUsers[i]._id });
                    response.data[tmpIndex].isPrevDisable = true;
                }
                setPrivileges(response.data);
                setFilterPrivileges(response.data)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const updatePrivilegePermission = async () => {
        try {
            if (customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setLoading(true)
            if (customerId !== null) {
                try {
                    const response = await updatePrivileges(customerId, privileges);
                    toastRef.current.showToast({
                        type: 'success',
                        message: controlUser + ' Permissions Updated Successfully'
                    });
                    getPermissions()
                } catch (error) {
                    console.error(error);
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false)
        }
    }

    const firstNameCheck = (rowData) => {
        if (rowData.firstname != null && rowData.firstname !== '') {
            return (
                <div className="form-label text-left"><div key={rowData._id}>{rowData.firstname}</div></div>
            );
        }
    };

    const surNameCheck = (rowData) => {
        if (rowData.surname != null && rowData.surname !== '') {
            return (
                <div className="form-label text-left"><div key={rowData._id}>{rowData.surname}</div></div>
            );
        }
    };

    const userNameCheck = (rowData) => {
        if (rowData.username != null && rowData.username !== '') {
            return (
                <div className="form-label text-left"><div key={rowData._id}>{rowData.username}</div></div>
            );
        }
    };

    const roleNameCheck = (rowData) => {
        if (rowData.role_name != null && rowData.role_name !== '') {
            return (
                <div className="form-label text-left"><div key={rowData._id}>{rowData.role_name}</div></div>
            );
        }
    };


    const adminCheck = (row, index) => {
        if (row.isAdmin != null && row.isAdmin !== '') {
            return (
                <CheckboxElement
                    id="isAdmin"
                    name="isAdmin"
                    checked={row.isAdmin}
                    onChangeCheck={(e) => handleIsAdminChange(e, index.rowIndex)}
                    className="mr-2"
                    disabled={row.isAdminDisable}
                />
            );
        }
    };

    const handleIsAdminChange = (e, rowIndex) => {
        if (privileges) {
            const updatedPrivilegesCopy = [...privileges];
            updatedPrivilegesCopy[rowIndex].isAdmin = e.target.checked;
            updatedPrivilegesCopy[rowIndex].user_privileges[0].planning = e.target.checked;
            updatedPrivilegesCopy[rowIndex].user_privileges[0].gate_closer = e.target.checked;
            updatedPrivilegesCopy[rowIndex].user_privileges[0].bid_status_edit = e.target.checked;
            updatedPrivilegesCopy[rowIndex].user_privileges[0].bid_team_edit = e.target.checked;
            updatedPrivilegesCopy[rowIndex].user_privileges[0].opp_delete = e.target.checked;
            updatedPrivilegesCopy[rowIndex].user_privileges[0].opp_edit = e.target.checked;
            updatedPrivilegesCopy[rowIndex].user_privileges[0].opp_add = e.target.checked;
            updatedPrivilegesCopy[rowIndex].user_privileges[0].contract = e.target.checked;
            updatedPrivilegesCopy[rowIndex].user_privileges[0].commercial = e.target.checked;
            updatedPrivilegesCopy[rowIndex].user_privileges[0].def_and_sec_opp_readwrite = e.target.checked;
            updatedPrivilegesCopy[rowIndex].user_privileges[0].benchmarking = e.target.checked;
            updatedPrivilegesCopy[rowIndex].user_privileges[0].stakeholder_comments = e.target.checked;
            updatedPrivilegesCopy[rowIndex].isPrevDisable = e.target.checked;
            setPrivileges(updatedPrivilegesCopy);
        }
    };

    const planningCheck = (row, index) => {
        if (row.user_privileges != null && row.user_privileges !== '') {
            return (
                <CheckboxElement
                    id="planning_privileges"
                    name="planning_privileges"
                    checked={row.user_privileges[0].planning}
                    onChangeCheck={(e) => PermissionChange(e, index.rowIndex, 'planning')}
                    className="mr-2"
                    disabled={row.isPrevDisable}
                />
            );
        }
    };

    const PermissionChange = (e, rowIndex, field1) => {
        const updatedPrivileges = [...privileges];
        updatedPrivileges[rowIndex].user_privileges[0][field1] = e.target.checked;
        setPrivileges(updatedPrivileges);
    };

    const defCheck = (row, index) => {
        if (row.user_privileges != null && row.user_privileges !== '') {
            return (
                <CheckboxElement
                    id="opp_readwrite"
                    name="opp_readwrite"
                    checked={row.user_privileges[0].def_and_sec_opp_readwrite}
                    onChangeCheck={(e) => PermissionChange(e, index.rowIndex, 'def_and_sec_opp_readwrite')}
                    className="mr-2"
                    disabled={row.isPrevDisable}
                />
            );
        }
    };

    const gateCloserCheck = (row, index) => {
        if (row.user_privileges != null && row.user_privileges !== '') {
            return (
                <CheckboxElement
                    id="gate_closer"
                    name="gate_closer"
                    checked={row.user_privileges[0].gate_closer}
                    onChangeCheck={(e) => PermissionChange(e, index.rowIndex, 'gate_closer')}
                    className="mr-2"
                    disabled={row.isPrevDisable}
                />
            );
        }
    };

    const bidStatusCheck = (row, index) => {
        if (row.user_privileges != null && row.user_privileges !== '') {
            return (
                <CheckboxElement
                    id="bid_status_edit"
                    name="bid_status_edit"
                    checked={row.user_privileges[0].bid_status_edit}
                    onChangeCheck={(e) => PermissionChange(e, index.rowIndex, 'bid_status_edit')}
                    className="mr-2"
                    disabled={row.isPrevDisable}
                />
            );
        }
    };

    const bidTeamCheck = (row, index) => {
        if (row.user_privileges != null && row.user_privileges !== '') {
            return (
                <CheckboxElement
                    id="bid_team_edit"
                    name="bid_team_edit"
                    checked={row.user_privileges[0].bid_team_edit}
                    onChangeCheck={(e) => PermissionChange(e, index.rowIndex, 'bid_team_edit')}
                    className="mr-2"
                    disabled={row.isPrevDisable}
                />
            );
        }
    };

    const oppCheck = (row, index) => {
        if (row.user_privileges != null && row.user_privileges !== '') {
            return (
                <CheckboxElement
                    id="opp_delete"
                    name="opp_delete"
                    checked={row.user_privileges[0].opp_delete}
                    onChangeCheck={(e) => PermissionChange(e, index.rowIndex, 'opp_delete')}
                    className="mr-2"
                    disabled={row.isPrevDisable}
                />
            );
        }
    };

    const oppEditCheck = (row, index) => {
        if (row.user_privileges != null && row.user_privileges !== '') {
            return (
                <CheckboxElement
                    id="opp_edit"
                    name="opp_edit"
                    checked={row.user_privileges[0].opp_edit}
                    onChangeCheck={(e) => PermissionChange(e, index.rowIndex, 'opp_edit')}
                    className="mr-2"
                    disabled={row.isPrevDisable}
                />
            );
        }
    };

    const oppAddCheck = (row, index) => {
        if (row.user_privileges != null && row.user_privileges !== '') {
            return (
                <CheckboxElement
                    id="opp_add"
                    name="opp_add"
                    checked={row.user_privileges[0].opp_add}
                    onChangeCheck={(e) => PermissionChange(e, index.rowIndex, 'opp_add')}
                    className="mr-2"
                    disabled={row.isPrevDisable}
                />
            );
        }
    };

    const contractCheck = (row, index) => {
        if (row.user_privileges != null && row.user_privileges !== '') {
            return (
                <CheckboxElement
                    id="contract"
                    name="contract"
                    checked={row.user_privileges[0].contract}
                    onChangeCheck={(e) => PermissionChange(e, index.rowIndex, 'contract')}
                    className="mr-2"
                    disabled={row.isPrevDisable}
                />
            );
        }
    };

    const commercialCheck = (row, index) => {
        if (row.user_privileges != null && row.user_privileges !== '') {
            return (
                <CheckboxElement
                    id="commercial"
                    name="commercial"
                    checked={row.user_privileges[0].commercial}
                    onChangeCheck={(e) => PermissionChange(e, index.rowIndex, 'commercial')}
                    className="mr-2"
                    disabled={row.isPrevDisable}
                />
            );
        }
    };

    const benchmarkingCheck = (row, index) => {
        if (row.user_privileges != null && row.user_privileges !== '') {
            return (
                <CheckboxElement
                    id="benchmarking"
                    name="benchmarking"
                    checked={row.user_privileges[0].benchmarking}
                    onChangeCheck={(e) => PermissionChange(e, index.rowIndex, 'benchmarking')}
                    className="mr-2"
                    disabled={row.isPrevDisable}
                />
            );
        }
    };

    const stakeHolderCheck = (row, index) => {
        if (row.user_privileges != null && row.user_privileges !== '') {
            return (
                <CheckboxElement
                    id="stakeholder_comments"
                    name="stakeholder_comments"
                    checked={row.user_privileges[0].stakeholder_comments}
                    onChangeCheck={(e) => PermissionChange(e, index.rowIndex, 'stakeholder_comments')}
                    className="mr-2"
                    disabled={row.isPrevDisable}
                />
            );
        }
    };


    const columns = [
        {
            field: "firstname",
            header: _.find(controlPermissionHeader, { header_name: "Firstname" })?.display_name,
            body: firstNameCheck,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "surname",
            header: _.find(controlPermissionHeader, { header_name: "Surname" })?.display_name,
            body: surNameCheck,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "username",
            header: _.find(controlPermissionHeader, { header_name: "Username" })?.display_name,
            body: userNameCheck,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "role_name",
            header: _.find(controlPermissionHeader, { header_name: "Role" })?.display_name,
            body: roleNameCheck,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "admin",
            header: _.find(controlPermissionHeader, { header_name: "Admin" })?.display_name,
            body: adminCheck,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "planning",
            header: _.find(controlPermissionHeader, { header_name: "Planning" })?.display_name,
            body: planningCheck,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "Defence",
            header: _.find(controlPermissionHeader, { header_name: "Defence & Security" })?.display_name,
            body: defCheck,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "gate_closer",
            header: _.find(controlPermissionHeader, { header_name: "Gate Closer" })?.display_name,
            body: gateCloserCheck,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "bid_status_edit",
            header: _.find(controlPermissionHeader, { header_name: "Edit Status" })?.display_name,
            body: bidStatusCheck,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "bid_team_edit",
            header: _.find(controlPermissionHeader, { header_name: "Edit Team" })?.display_name,
            body: bidTeamCheck,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "opp_delete",
            header: _.find(controlPermissionHeader, { header_name: "Delete Projects" })?.display_name,
            body: oppCheck,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "opp_edit",
            header: _.find(controlPermissionHeader, { header_name: "Edit Projects" })?.display_name,
            body: oppEditCheck,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "opp_add",
            header: _.find(controlPermissionHeader, { header_name: "Add Projects" })?.display_name,
            body: oppAddCheck,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "contract",
            header: _.find(controlPermissionHeader, { header_name: "Contract Summary" })?.display_name,
            body: contractCheck,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "commercial",
            header: _.find(controlPermissionHeader, { header_name: "Commercial Summary" })?.display_name,
            body: commercialCheck,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "benchmarking",
            header: _.find(controlPermissionHeader, { header_name: "Benchmarking" })?.display_name,
            body: benchmarkingCheck,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "stakeholder_comments",
            header: _.find(controlPermissionHeader, { header_name: "Stakeholder Comments" })?.display_name,
            body: stakeHolderCheck,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        }
    ]

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        filteredQuestionsArray(e.target.value);
    };

    const handleClearFilter = () => {
        setSearchQuery("");
        filteredQuestionsArray("");
        getPermissions();
    };

    const filteredQuestionsArray = (query) => {
        // Convert the query to lowercase for case-insensitive comparison
        const lowerCaseQuery = query.toLowerCase();

        if (lowerCaseQuery.length === 0) {
            // If the query is empty, retrieve the full customer field data
            getPermissions();
            setSearchedLength(lowerCaseQuery.length); // Update the searched length after resetting the data


        } else {
            if (lowerCaseQuery.length > searchedLength) {
                setSearchedLength(lowerCaseQuery.length);
            } else {
                setSearchedLength(lowerCaseQuery.length);
            }

            // Filter the customer reference data if the query is not empty
            const filteredData = filterPrivileges.filter(item => {
                // Check if any value in the item includes the query string
                return Object.values(item).some(value => {
                    // Convert value to string and to lowercase for comparison
                    // return value.toString().toLowerCase().includes(lowerCaseQuery);
                    return value !== null && value !== undefined && value.toString().toLowerCase().includes(lowerCaseQuery);

                });
            });
            // Update the state with the filtered data
            setPrivileges(filteredData);
        }
    }

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    return (

        <div className='new-field'>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div>
                {
                    <div className="form-group row align-items-center mb-0 mt-0">
                        <div className="col pr-0">
                            <div className="form-group row align-items-center mb-0">
                                <div className="col-md-4 pl-0">
                                    <p className="label-text">
                                        {cntlPannel_Permissions}
                                    </p>
                                    <p className="group-table-text-section">
                                        Please tick and untick the permissions associated with each user
                                    </p>
                                </div>
                                <div className="col pr-0 d-flex justify-end">
                                    <div className="group-table-search ">
                                        <HeaderSearchBar
                                            value={searchQuery}
                                            onChange={(e) => handleSearchChange(e)}
                                            onClick={handleClearFilter}
                                        />
                                    </div>
                                    <div>
                                        <ButtonElement className="upload-button ml-2" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
                                    </div>
                                </div>
                            </div>
                            <div className="data-submit">
                                <DataTable
                                    value={privileges}
                                    columns={columns}
                                    dataKey="_id"
                                    isPermissions={true}
                                    rowClick={rowClick}
                                    searchQuery={searchQuery}
                                    header={true}
                                />
                            </div>
                        </div>
                    </div>
                }
                {
                    <div className="col pr-0 d-flex justify-end">
                        <ButtonElement className="save-button" type="submit" onClick={updatePrivilegePermission} label="Update" />
                    </div>
                }
            </div>
            <div>
                <Dialog
                    visible={visible}
                    onHide={handleHide}
                    className="width-50vw"
                    header="User Detail"
                    position="right"
                    footer={renderFooter}
                    draggable={false}
                >
                    <div className="new-field">
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                                <label className="form-label text-left font-bold">{_.find(controlPermissionHeader, { header_name: "Firstname" })?.display_name}</label>
                            </div>
                            <div className="col pr-0">
                                <label className="form-label text-left">
                                    {selectedPrivileges?.firstname}
                                </label>
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                                <label className="form-label text-left font-bold">{_.find(controlPermissionHeader, { header_name: "Surname" })?.display_name}</label>
                            </div>
                            <div className="col pr-0">
                                <label className="form-label text-left">
                                    {selectedPrivileges?.surname}
                                </label>
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                                <label className="form-label text-left font-bold">{_.find(controlPermissionHeader, { header_name: "Username" })?.display_name}</label>
                            </div>
                            <div className="col pr-0">
                                <label className="form-label text-left">
                                    {selectedPrivileges?.username}
                                </label>
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                                <label className="form-label text-left font-bold">{_.find(controlPermissionHeader, { header_name: "Role" })?.display_name}</label>
                            </div>
                            <div className="col pr-0">
                                <label className="form-label text-left">
                                    {selectedPrivileges?.role_name}
                                </label>
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                                <label className="form-label text-left font-bold">{_.find(controlPermissionHeader, { header_name: "Business Unit" })?.display_name}</label>
                            </div>
                            <div className="col pr-0">
                                <label className="form-label text-left">
                                    {selectedPrivileges?.business_unit || '-'}
                                </label>
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                                <label className="form-label text-left font-bold">{_.find(controlPermissionHeader, { header_name: "Email" })?.display_name}</label>
                            </div>
                            <div className="col pr-0">
                                <label className="form-label text-left">
                                    {selectedPrivileges?.email}
                                </label>
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                                <label className="form-label text-left font-bold">{_.find(controlPermissionHeader, { header_name: "Phone number" })?.display_name}</label>
                            </div>
                            <div className="col pr-0">
                                <label className="form-label text-left">
                                    {selectedPrivileges?.phone_number || '-'}
                                </label>
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                                <label className="form-label text-left font-bold">{_.find(controlPermissionHeader, { header_name: "Mobile number" })?.display_name}</label>
                            </div>
                            <div className="col pr-0">
                                <label className="form-label text-left">
                                    {selectedPrivileges?.mobile_number || '-'}
                                </label>
                            </div>
                        </div>
                        <div className="group-table-data">
                            <table className="group-datatable activity">
                                <thead className="group-table-header">
                                    <tr>
                                        <th className="w-40">{_.find(controlPermissionHeader, { header_name: "Privilege" })?.display_name}</th>
                                        <th className="w-20">{_.find(controlPermissionTable, { table_name: "Permissions" })?.display_name}</th>
                                    </tr>
                                </thead>
                                <tbody className="group-table-row">
                                    <tr>
                                        <td><label className="form-label text-left">{_.find(controlPermissionHeader, { header_name: "Admin" })?.display_name}</label></td>
                                        <td className="w-40">
                                            {selectedPrivileges?.isAdmin ? (
                                                <span className="pi pi-check text-success fs-12"></span>
                                            ) : (
                                                <span className="pi pi-times text-danger fs-12"></span>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label className="form-label text-left">{_.find(controlPermissionHeader, { header_name: "Planning" })?.display_name}</label></td>
                                        <td className="w-40">
                                            {selectedPrivileges?.user_privileges?.[0]?.planning ? (
                                                <span className="pi pi-check text-success fs-12"></span>
                                            ) : (
                                                <span className="pi pi-times text-danger fs-12"></span>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label className="form-label text-left">{_.find(controlPermissionHeader, { header_name: "Defence & Security" })?.display_name}</label></td>
                                        <td className="w-40">
                                            {selectedPrivileges?.user_privileges?.[0]?.def_and_sec_opp_readwrite ? (
                                                <span className="pi pi-check text-success fs-12"></span>
                                            ) : (
                                                <span className="pi pi-times text-danger fs-12"></span>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label className="form-label text-left">{_.find(controlPermissionHeader, { header_name: "Gate Closer" })?.display_name}</label></td>
                                        <td className="w-40">
                                            {selectedPrivileges?.user_privileges?.[0]?.gate_closer ? (
                                                <span className="pi pi-check text-success fs-12"></span>
                                            ) : (
                                                <span className="pi pi-times text-danger fs-12"></span>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label className="form-label text-left">{_.find(controlPermissionHeader, { header_name: "Edit Status" })?.display_name}</label></td>
                                        <td className="w-40">
                                            {selectedPrivileges?.user_privileges?.[0]?.bid_status_edit ? (
                                                <span className="pi pi-check text-success fs-12"></span>
                                            ) : (
                                                <span className="pi pi-times text-danger fs-12"></span>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label className="form-label text-left">{_.find(controlPermissionHeader, { header_name: "Edit Team" })?.display_name}</label></td>
                                        <td className="w-40">
                                            {selectedPrivileges?.user_privileges?.[0]?.bid_team_edit ? (
                                                <span className="pi pi-check text-success fs-12"></span>
                                            ) : (
                                                <span className="pi pi-times text-danger fs-12"></span>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label className="form-label text-left">{_.find(controlPermissionHeader, { header_name: "Delete Projects" })?.display_name}</label></td>
                                        <td className="w-40">
                                            {selectedPrivileges?.user_privileges?.[0]?.opp_delete ? (
                                                <span className="pi pi-check text-success fs-12"></span>
                                            ) : (
                                                <span className="pi pi-times text-danger fs-12"></span>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label className="form-label text-left">{_.find(controlPermissionHeader, { header_name: "Edit Projects" })?.display_name}</label></td>
                                        <td className="w-40">
                                            {selectedPrivileges?.user_privileges?.[0]?.opp_edit ? (
                                                <span className="pi pi-check text-success fs-12"></span>
                                            ) : (
                                                <span className="pi pi-times text-danger fs-12"></span>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label className="form-label text-left">{_.find(controlPermissionHeader, { header_name: "Add Projects" })?.display_name}</label></td>
                                        <td className="w-40">
                                            {selectedPrivileges?.user_privileges?.[0]?.opp_add ? (
                                                <span className="pi pi-check text-success fs-12"></span>
                                            ) : (
                                                <span className="pi pi-times text-danger fs-12"></span>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label className="form-label text-left">{_.find(controlPermissionHeader, { header_name: "Contract Summary" })?.display_name}</label></td>
                                        <td className="w-40">
                                            {selectedPrivileges?.user_privileges?.[0]?.contract ? (
                                                <span className="pi pi-check text-success fs-12"></span>
                                            ) : (
                                                <span className="pi pi-times text-danger fs-12"></span>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label className="form-label text-left">{_.find(controlPermissionHeader, { header_name: "Commercial Summary" })?.display_name}</label></td>
                                        <td className="w-40">
                                            {selectedPrivileges?.user_privileges?.[0]?.commercial ? (
                                                <span className="pi pi-check text-success fs-12"></span>
                                            ) : (
                                                <span className="pi pi-times text-danger fs-12"></span>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label className="form-label text-left">{_.find(controlPermissionHeader, { header_name: "Benchmarking" })?.display_name}</label></td>
                                        <td className="w-40">
                                            {selectedPrivileges?.user_privileges?.[0]?.benchmarking ? (
                                                <span className="pi pi-check text-success fs-12"></span>
                                            ) : (
                                                <span className="pi pi-times text-danger fs-12"></span>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label className="form-label text-left">{_.find(controlPermissionHeader, { header_name: "Stakeholder Comments" })?.display_name}</label></td>
                                        <td className="w-40">
                                            {selectedPrivileges?.user_privileges?.[0]?.stakeholder_comments ? (
                                                <span className="pi pi-check text-success fs-12"></span>
                                            ) : (
                                                <span className="pi pi-times text-danger fs-12"></span>
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Dialog>

                <Dialog id="videoModal" visible={showVideo}
                    breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                    }}
                    modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
                >
                    <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_CONTROL_PANEL_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="control_panel_permissions" />
                    </div>
                    </div>
                </Dialog>
            </div>
        </div>
    )
}

export default Permissions;